// <details data-popover> behaves like a popover: a click outside or Escape closes it, and
// opening one closes the others.
const closeAll = (except) => {
  document.querySelectorAll("details[data-popover][open]").forEach((details) => {
    if (details !== except) details.open = false
  })
}

document.addEventListener("click", (event) => {
  closeAll(event.target.closest("details[data-popover]"))
})

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeAll(null)
})
